<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" width="600px">
      <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
      <v-card>
        <v-card-title>
          <span v-if="index == 0" class="headline">
              {{latestNews[index].title}}
          </span>
          <span v-if="index > 0" class="headline">
              {{newsArray[index].title}}
          </span>
        </v-card-title>
        <v-card-text v-if="index == 0">
            {{latestNews[index].text}}
        </v-card-text>
        <v-card-text v-if="index > 0">
            {{newsArray[index].text}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    props: {
        index: Number,
        open: Boolean,
    },
    data () {
      return {
        dialog: false
      }
    },
    computed: {
        ...mapState('ContactModule', ['newsArray', 'latestNews']),
    },
    watch: {
        open(val){
            this.dialog = val;
        }
    }
  }
</script>